<template>
  <Transition name="loading-fade">
    <div class="loading_container" v-if="loadingContent.length > 0" :style="loadingStyle">
      <div class="loading_message">
        <div class="loading_content">
          <div class="loading">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <span class="loading_text">{{ loadingContent }}</span>
        </div>
      </div>
    </div>
  </Transition>
</template>
<script lang="ts">
const loadingContent = ref('')
export { loadingContent }
</script>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { zIndexLayers } from '@/service/ui/z_index'

const loadingStyle = {
  '--mgx-loading-z-index': String(zIndexLayers.loading),
}

let task: NodeJS.Timeout
watch(
  () => loadingContent.value,
  (value: string) => {
    if (value.length > 0) {
      task = setTimeout(() => {
        loadingContent.value = ''
      }, 1000 * 60)
    } else {
      clearTimeout(task)
    }
  },
)
</script>
<style lang="less" scoped>
.loading_container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--mgx-loading-z-index);
  /* 毛玻璃背景效果 */
  // background: rgba(255, 255, 255, 0.6);
  // backdrop-filter: blur(20px) saturate(180%);
  -webkit-app-region: no-drag;
  cursor: not-allowed;

  .loading_message {
    margin: 0px auto;
    padding: 32px 56px;
    /* 纯净白面板 */
    background: var(--bg-subtle);
    border-radius: var(--radius-l);
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 1);
    max-width: 80%;
    transition: var(--transition-base);

    .loading_content {
      display: flex;
      align-items: center;

      .loading_text {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.5;
        color: var(--color-dark);
        margin-left: 24px;
        letter-spacing: 0.5px;
      }
    }
  }
}

.loading,
.loading > div {
  position: relative;
  box-sizing: border-box;
}

.loading {
  display: block;
  font-size: 0;
  /* 使用品牌色纯色 */
  color: var(--brand-color-pure);
}

.loading.la-dark {
  color: var(--color-dark);
}

.loading > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loading {
  width: 32px;
  height: 32px;
}

.loading > div {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  margin-left: -4px;
  border-radius: 100%;
  animation: ball-spin-clockwise 1s infinite ease-in-out;
}

/* Lines 123-456 omitted in original file, but I should probably keep the animation logic */
.loading > div:nth-child(1) {
  top: 5%;
  left: 50%;
  animation-delay: -0.875s;
}

.loading > div:nth-child(2) {
  top: 18.1801948466%;
  left: 81.8198051534%;
  animation-delay: -0.75s;
}

.loading > div:nth-child(3) {
  top: 50%;
  left: 95%;
  animation-delay: -0.625s;
}

.loading > div:nth-child(4) {
  top: 81.8198051534%;
  left: 81.8198051534%;
  animation-delay: -0.5s;
}

.loading > div:nth-child(5) {
  top: 94.9999999966%;
  left: 50.0000000005%;
  animation-delay: -0.375s;
}

.loading > div:nth-child(6) {
  top: 81.8198046966%;
  left: 18.1801949248%;
  animation-delay: -0.25s;
}

.loading > div:nth-child(7) {
  top: 49.9999750815%;
  left: 5.0000051215%;
  animation-delay: -0.125s;
}

.loading > div:nth-child(8) {
  top: 18.179464974%;
  left: 18.1803700518%;
  animation-delay: 0s;
}

@keyframes ball-spin-clockwise {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  20% {
    opacity: 1;
  }

  80% {
    opacity: 0;
    transform: scale(0);
  }
}

.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: all 0.3s var(--transition-base);
}

.loading-fade-enter-from,
.loading-fade-leave-to {
  opacity: 0;
  backdrop-filter: blur(0px);

  .loading_message {
    transform: scale(0.9);
    opacity: 0;
  }
}
</style>
